
import { TEMPLATE_JOB_ID } from '@/utils/jobs'

export default {
  name: 'JobForm',
  props: {
    jobId: {
      type: [Number, String],
      default: TEMPLATE_JOB_ID,
      required: false,
    },
  },
  data() {
    return {
      isLoading: true,
      error: false,
      timeoutRef: null,
    }
  },
  methods: {
    loadForm() {
      if (window.Grnhse?.Iframe) {
        window.Grnhse.Iframe.load(this.jobId)
        this.isLoading = false
      } else {
        this.error = true
      }
    },
  },
}
